import { SearchSttFilter } from "@/data/payload/api/CariSttApiRequest";
import { CariSttRequest } from "@/domain/entities/ListCariSTT";

export class CariSTTEndpoint {
  getCariSTTList(params: CariSttRequest) {
    return `/hydra/v1/stt-search?${params.toQueryString()}`;
  }

  getDownloadCariSTTList(id: number) {
    return `hydra/v1/stt-search/${id}/download`;
  }

  getDetailSttScan(id: number) {
    return `hydra/v1/stt-search/${id}`;
  }

  searchSttScan() {
    return "hydra/v1/stt-search/scan";
  }

  getSearchSttScanList(params: SearchSttFilter) {
    return `hydra/v1/stt-search/scan?${params.toQueryString()}`;
  }

  searchStt() {
    return "hydra/v1/stt-search";
  }
}
